import { render, staticRenderFns } from "./ActParceiro.vue?vue&type=template&id=4cd60750&scoped=true&"
import script from "./ActParceiro.vue?vue&type=script&lang=js&"
export * from "./ActParceiro.vue?vue&type=script&lang=js&"
import style0 from "./ActParceiro.vue?vue&type=style&index=0&id=4cd60750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd60750",
  null
  
)

export default component.exports